import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watchEffect} from "vue";
import { DataInstance } from "@busy-human/gearbox";
import { Userspaces } from "@busy-human/k9-library";
import { useUserspace } from "@/store/useUsers";
import NewCustomerPopup from "../components/new-customer-popup.vue";
import customerList from "../components/customer-list.vue";
import customerDetails from "../components/customer-details.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'customers',
  setup(__props, { expose: __expose }) {
  __expose();

const userSpace = useUserspace();
const showCreateUser = ref(false);
// eslint-disable-next-line vue/no-side-effects-in-computed-properties
const customers = computed<DataInstance<Userspaces.Model>[]>(() => userSpace.asArray
	.sort((a,b) => {
		if(a?.name?.firstName && !b?.name?.firstName) return -1;
		else if(b?.name?.firstName && !a?.name?.firstName) return 1;
		else if(a?.name?.firstName && b?.name?.firstName) return a.name.firstName < b.name.firstName ? -1 : 1;
		else return a.email < b.email ? -1 : 1;
	}));
const handlePopup = ()=>{
	console.log("recieved emit");
	showCreateUser.value = !showCreateUser.value;
};

const selectedUser = ref<DataInstance<Userspaces.Model> | undefined>();

watchEffect(()=>{
	if(customers.value && customers.value[0]?.email?.length > 3){
		[selectedUser.value] = customers.value;
	}
});


const __returned__ = { userSpace, showCreateUser, customers, handlePopup, selectedUser, ref, computed, watchEffect, get DataInstance() { return DataInstance }, get Userspaces() { return Userspaces }, get useUserspace() { return useUserspace }, NewCustomerPopup, customerList, customerDetails }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})